import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IKomutTanim, komutVarsayilan } from './fiko-komut.tanim';
import { FIKO_KONTROL_STIL } from './fiko-kontrol-stil';
import { FikoDuzlemSecici } from './FikoDuzlemSecici';
import { FikoSecimListesi } from './FikoSecimListesi';

/**
 * Komut formu — FikoDialogCore içinde barındırılır (kabuk/başlık/sürükleme/kapat DialogCore'da).
 * Param değişince CANLI önizleme (yonetici.komutGuncelle), Tamam→komutOnayla, İptal/Esc→komutIptal.
 * Kapatma: pencere.instance.kapa(). X/ESC ile kapanırsa ngOnDestroy taslağı geri alır.
 */
@Component({
  selector: 'fikoyt-komut-icerik',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoDuzlemSecici, FikoSecimListesi],
  template: `
  <div class="fk" (keydown)="tus($event)">
    <div class="fk-govde">
      <div class="fk-satir" [class.dik]="p.tip==='secim'" *ngFor="let p of gorunenParametreler(); trackBy: trk">
        <label>{{ p.etiket }}</label>
        @switch (p.tip) {
          @case ('duzlemRef') {
            <fikoyt-duzlem-secici [element]="yonetici?.taslakFeatAktif" [yonetici]="yonetici" [anahtar]="p.anahtar" [tur]="'duzlem'" [mod]="'komut'"></fikoyt-duzlem-secici>
          }
          @case ('eksenRef') {
            <fikoyt-duzlem-secici [element]="yonetici?.taslakFeatAktif" [yonetici]="yonetici" [anahtar]="p.anahtar" [tur]="'eksen'" [mod]="'komut'"></fikoyt-duzlem-secici>
          }
          @case ('ref') {
            <button class="fk-ref" [class.aktif]="yonetici?.refSecAktif && yonetici?.refSecHedef?.()===p.anahtar" (click)="refSec(p)">
              <i class="cursor"></i>{{ refEtiket(p) }}
            </button>
          }
          @case ('metin') {
            <input class="fk-metin" type="text" [ngModel]="deger[p.anahtar]" (ngModelChange)="degistir(p, $event)" placeholder="Yazı…" />
          }
          @case ('boolean') {
            <button class="fk-bool" [class.acik]="!!deger[p.anahtar]" (click)="degistir(p, !deger[p.anahtar])">{{ deger[p.anahtar] ? 'Evet' : 'Hayır' }}</button>
          }
          @case ('secim') {
            <div class="fk-secim">
              <button *ngFor="let s of p.secenekler" class="fk-sec" [class.aktif]="deger[p.anahtar]===s.deger" (click)="degistir(p, s.deger)">{{ s.etiket }}</button>
            </div>
          }
          @default {
            <div class="fk-inp">
              <input class="fk-in" type="number" [ngModel]="deger[p.anahtar]" (ngModelChange)="degistir(p, $event)" [min]="p.min ?? null" [max]="p.max ?? null" [step]="p.adim ?? 1" />
              <span class="fk-birim" *ngIf="p.birim">{{ p.birim }}</span>
            </div>
          }
        }
      </div>
      @if(secimListeTip(); as st){
        <fikoyt-secim-listesi [element]="yonetici?.taslakFeatAktif" [yonetici]="yonetici" [tip]="st"></fikoyt-secim-listesi>
      } @else {
        <div class="fk-bos" *ngIf="!tanim?.parametreler?.length">Önizleme — Tamam ile uygula.</div>
      }
      <div class="fk-kenar-bilgi" *ngIf="yonetici?.cam3dSonMeta as cm">
        <i class="cog"></i>{{ cm.operasyon }}: {{ cm.nokta }} nokta · {{ cm.toplamMesafe }} mm · ~{{ cm.sureDk }} dk
      </div>
      <div class="fk-kenar-bilgi" *ngIf="yonetici?.profilSecimAktif">
        <i class="cursor"></i>
        @if(tanim?.id === 'loft'){ {{ yonetici.seciliProfilSayisi >= 2 ? (yonetici.seciliProfilSayisi + ' kesit seçildi — Tamam') : ('Sırayla 2+ kesit profili seçin (' + yonetici.seciliProfilSayisi + ' seçili / ' + yonetici.profilAdaySayisi + ' var)') }} }
        @else if(tanim?.id === 'sweep'){ {{ yonetici.seciliProfilSayisi >= 2 ? 'Profil + yol seçildi — Tamam' : (yonetici.seciliProfilSayisi === 1 ? 'Şimdi YOL eskizine tıklayın' : ('Önce PROFİL eskizine tıklayın (' + yonetici.profilAdaySayisi + ' eskiz var)')) }} }
        @else { {{ yonetici.profilSecildiMi ? 'Profil seçildi — ayarlayıp Tamam' : (yonetici.profilAdaySayisi ? ('3D ortamda profil/eskize tıklayın (' + yonetici.profilAdaySayisi + ' profil var)') : 'Önce bir eskiz çizin ve Bitir ile bitirin') }} }
      </div>
    </div>
    <div class="fk-altbar">
      <button class="fk-btn iptal fk-btn-genis" (click)="iptal()">İptal</button>
      <button class="fk-btn tamam fk-btn-genis" (click)="tamam()">Tamam</button>
    </div>
  </div>
  `,
  styles: [FIKO_KONTROL_STIL, `
    .fk { min-width: 176px; }
    .fk-kenar-bilgi { margin-top: 6px; padding: 5px 7px; font-size: 10px; border-radius: 4px;
      background: rgba(0,200,120,.15); border: 1px solid rgba(0,255,136,.4); color: #8fffc4;
      display: flex; align-items: center; gap: 6px; }
    .fk-kenar-bilgi .cursor { width: 8px; height: 8px; border-radius: 50%; background: #00ff88; animation: fkNabiz 1.2s infinite; }
    .fk-ref { display:flex; align-items:center; gap:6px; flex:1; padding:5px 8px; border-radius:7px; font-size:12px; cursor:pointer;
      background:rgba(56,189,248,.12); border:1px solid rgba(56,189,248,.35); color:var(--py-metin,#e6f1ff); transition:all .15s; }
    .fk-ref:hover { background:rgba(56,189,248,.22); border-color:rgba(56,189,248,.6); }
    .fk-ref.aktif { background:rgba(250,204,21,.18); border-color:rgba(250,204,21,.6); animation:fkNabiz 1s infinite; }
    .fk-ref .cursor { width:8px; height:8px; border-radius:50%; background:#38bdf8; }
    @keyframes fkNabiz { 0%,100% { opacity: 1; } 50% { opacity: .3; } }
  `]
})
export class FikoKomutIcerik implements OnInit, OnDestroy {
  @Input() tanim!: IKomutTanim;
  @Input() yonetici: any;
  @Input() pencere: any;   // { instance: FikoDialogCore } — DialogCore otomatik geçer

  deger: Record<string, any> = {};
  private onaylandi = false;
  private acildi = false;

  constructor(public CD: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.deger = komutVarsayilan(this.tanim);
    const ok = this.yonetici?.komutBaslat?.(this.tanim.id, this.deger);
    this.acildi = !!ok;
    if (!ok) { this.kapat(); return; }   // ön koşul yoksa kapan
  }
  ngOnDestroy(): void { if (this.acildi && !this.onaylandi) this.yonetici?.komutIptal?.(); }   // X/ESC ile kapanırsa geri al

  /** Bu komut yüz/kenar seçim listesiyle mi çalışıyor? → liste paneli göster. */
  private static SECIM_TIP: Record<string, 'yuz' | 'kenar'> = {
    fillet3d: 'kenar', chamfer3d: 'kenar',
    draft: 'yuz', shell: 'yuz', removeFace: 'yuz', thickness: 'yuz', faceFillet: 'yuz', triFillet: 'yuz', replaceFace: 'yuz',
  };
  secimListeTip(): 'yuz' | 'kenar' | null { return FikoKomutIcerik.SECIM_TIP[this.tanim?.id] || null; }

  trk = (_: number, p: any) => p.anahtar;
  gorunenParametreler(): any[] { return (this.tanim?.parametreler || []).filter(p => !p.gorunur || p.gorunur(this.deger)); }
  refSec(p: any): void { this.yonetici?.komutRefSec?.(this.yonetici?.taslakFeatAktif, p.anahtar, p.refTipler || ['nokta3d', 'cizgi3d'], () => this.CD.markForCheck()); }
  refEtiket(p: any): string { return this.yonetici?.refAdi?.(this.yonetici?.taslakFeatAktif, p.anahtar) || 'Seç (3D)'; }
  degistir(p: any, deger: any): void { this.deger[p.anahtar] = deger; this.yonetici?.komutGuncelle?.(p.anahtar, deger); this.CD.markForCheck(); }
  tamam(): void { this.onaylandi = true; this.yonetici?.komutOnayla?.(); this.kapat(); }
  iptal(): void { this.yonetici?.komutIptal?.(); this.acildi = false; this.kapat(); }
  tus(e: KeyboardEvent): void { if (e.key === 'Enter') this.tamam(); }
  @HostListener('document:keydown.escape') esc(): void { /* DialogCore ESC'yi yönetir → ngOnDestroy geri alır */ }

  private kapat(): void { try { this.pencere?.instance?.kapa?.(); } catch { } }
}
